import { render, staticRenderFns } from "./InstallmentOrderList.vue?vue&type=template&id=4a97a090&scoped=true"
import script from "./InstallmentOrderList.vue?vue&type=script&lang=js"
export * from "./InstallmentOrderList.vue?vue&type=script&lang=js"
import style0 from "./InstallmentOrderList.vue?vue&type=style&index=0&id=4a97a090&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97a090",
  null
  
)

export default component.exports